import { getEnvironmentSettings } from 'services/environment';
import c from 'common/constants/flux-events';
import http from 'utils/http';

const actions = {
    getAll() {
        return dispatch => {
            // Skip HTTP when CTV/DOOH inventory is disabled for this environment (e.g. Spain).
            if (!getEnvironmentSettings().canUseCTVOrDOOH()) {
                return Promise.resolve([]);
            }

            const promise = http()
                .get('ui-options/dooh-publishers')
                .then(
                    response => {
                        if (response.length > 0) {
                            dispatch({
                                type: c.SYSTEM__DOOH_PUBLISHERS__FETCH__SUCCESS,
                                payload: response,
                            });
                            return response;
                        }
                    },
                    err => {
                        console.error(`GET ALL dooh publishers error`, err);
                    }
                );

            return promise;
        };
    },
};

export default actions;
